<template>
  <div class="newtrend_mode_wraper">

    <div
      class="one_newtrend_mode_wraper"
      @click="modeBtnClickHandle(1)"
      :class=" mode === 1? 'one_newtrend_mode_wraper_active':''"
    >
      <img
        v-show=" mode === 1 "
        src="../../../assets/img/newtrend-mode/xinfeng-nei-active.png"
        alt
      />
      <img v-show=" mode != 1 " src="../../../assets/img/newtrend-mode/xinfeng-nei-no-active.png" alt />
      <div class="newtrend_mode_text">内循环</div>
    </div>

    <div
      class="one_newtrend_mode_wraper one_newtrend_mode_wraper_margin"
      @click="modeBtnClickHandle(2)"
      :class=" mode === 2? 'one_newtrend_mode_wraper_active':''"
    >
      <img
        v-show=" mode === 2 "
        src="../../../assets/img/newtrend-mode/xinfeng-wai-active.png"
        alt
      />
      <img v-show=" mode != 2 " src="../../../assets/img/newtrend-mode/xinfeng-wai-no-active.png" alt />
      <div class="newtrend_mode_text">外循环</div>
    </div>


  </div>
</template>

<script>
//1,内循环 2，外循环
export default {
  data() {
    return {
      mode: this.setMode
    };
  },
  props: {
    setMode: {
      type: Number,
      default: 1
    }
  },
  methods: {
    modeBtnClickHandle(m) {
      this.mode = m;
      this.$emit("airModeChange", this.mode); ///传给父组件
    }
  },
  watch: {
    setMode(val) {
      this.mode = val;
      this.$emit("airModeChange", this.mode); ///传给父组件
    }
  }
};
</script>

<style>
.newtrend_mode_wraper {
  width: 100%;
  height: 100px;
  /* border: 1px solid black; */
  color: #f5f5f5;

  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}
.one_newtrend_mode_wraper {
  width: 120px;
  height: 50px;
  border: 1px solid #f5f5f5;
  border-radius: 5px;

  display: flex;
  flex-direction: center;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}
.one_newtrend_mode_wraper_margin{
  margin-left: 40px
}
.one_newtrend_mode_wraper_active {
  background-color: #f5f5f5;
  color: #282828;
}
.one_newtrend_mode_wraper:active {
  background: #a0a3a5;
}
.one_newtrend_mode_wraper img {
  width: 34px;
  height: 34px;

  margin-right: 2px;
}
.newtrend_mode_text {
  font-size: 16px;
  margin-left: 2px;
  /* color: #f5f5f5; */
}
</style>